/**
 * Fullscreen mobile menu — matches DivsFlow reference behavior.
 */
document.addEventListener( 'DOMContentLoaded', function () {
	'use strict';

	const menu = document.getElementById( 'mobile-menu' );
	const openBtn = document.querySelector( '.mobile-menu-trigger' );

	if ( ! menu || ! openBtn ) {
		return;
	}

	const closeBtn = menu.querySelector( '.mobile-menu__close' );
	const menuItems = menu.querySelectorAll( '.mobile-menu__navbar .main-menu > li' );
	const parentLinks = menu.querySelectorAll( '.mobile-menu__link--parent' );

	function slideDown( el, duration = 400 ) {
		el.style.removeProperty( 'display' );
		let display = window.getComputedStyle( el ).display;
		if ( display === 'none' ) {
			display = 'block';
		}
		el.style.display = display;
		const height = el.scrollHeight;
		el.style.overflow = 'hidden';
		el.style.height = '0';
		el.offsetHeight;
		el.style.transition = 'height ' + duration + 'ms ease';
		el.style.height = height + 'px';
		window.setTimeout( function () {
			el.style.removeProperty( 'height' );
			el.style.removeProperty( 'overflow' );
			el.style.removeProperty( 'transition' );
		}, duration );
	}

	function slideUp( el, duration = 400 ) {
		el.style.height = el.scrollHeight + 'px';
		el.offsetHeight;
		el.style.transition = 'height ' + duration + 'ms ease';
		el.style.height = '0';
		el.style.overflow = 'hidden';
		window.setTimeout( function () {
			el.style.display = 'none';
			el.style.removeProperty( 'height' );
			el.style.removeProperty( 'overflow' );
			el.style.removeProperty( 'transition' );
		}, duration );
	}

	function slideToggle( el, duration = 400 ) {
		if ( window.getComputedStyle( el ).display === 'none' ) {
			slideDown( el, duration );
		} else {
			slideUp( el, duration );
		}
	}

	function resetSubmenus() {
		parentLinks.forEach( function ( link ) {
			link.classList.remove( 'dopen' );
		} );
		menu.querySelectorAll( '.mobile-menu__sub' ).forEach( function ( sub ) {
			sub.classList.remove( 'sub-open' );
			sub.style.display = 'none';
		} );
	}

	function openMenu() {
		menu.classList.add( 'open' );
		menu.setAttribute( 'aria-hidden', 'false' );
		openBtn.setAttribute( 'aria-expanded', 'true' );
		document.body.classList.add( 'mobile-menu-open', 'no-overflow' );
	}

	function closeMenu() {
		menu.classList.remove( 'open' );
		menu.setAttribute( 'aria-hidden', 'true' );
		openBtn.setAttribute( 'aria-expanded', 'false' );
		document.body.classList.remove( 'mobile-menu-open', 'no-overflow' );

		resetSubmenus();
		menuItems.forEach( function ( item ) {
			item.classList.remove( 'hoverd' );
		} );
	}

	openBtn.addEventListener( 'click', openMenu );
	closeBtn.addEventListener( 'click', closeMenu );

	menuItems.forEach( function ( item ) {
		item.addEventListener( 'mouseenter', function () {
			item.classList.remove( 'hoverd' );
			menuItems.forEach( function ( sibling ) {
				if ( sibling !== item ) {
					sibling.classList.add( 'hoverd' );
				}
			} );
		} );

		item.addEventListener( 'mouseleave', function () {
			menuItems.forEach( function ( sibling ) {
				sibling.classList.remove( 'hoverd' );
			} );
		} );
	} );

	parentLinks.forEach( function ( link ) {
		link.addEventListener( 'click', function ( e ) {
			const li = link.closest( 'li' );
			const subMenu = li ? li.querySelector( ':scope > .mobile-menu__sub' ) : null;

			if ( ! subMenu ) {
				return;
			}

			e.preventDefault();
			subMenu.classList.toggle( 'sub-open' );
			slideToggle( subMenu );
			link.classList.toggle( 'dopen' );
		} );
	} );

	document.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' && menu.classList.contains( 'open' ) ) {
			closeMenu();
		}
	} );
} );
